import ActionButton from '@source/components/ActionButton';
import { useState } from 'react';
import DownloadModal from '../DownloadModal';
import * as S from './styles';

const Canvas: React.FC = (): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <S.Container>
      <S.BlueBox>
        <S.Wrapper>
          <S.MainBox>
            <S.Logo>Riderize</S.Logo>
          </S.MainBox>

          <S.Text>
            6 passos para organizar um{' '}
            <S.Bold>evento virtual de ciclismo</S.Bold> de{' '}
            <S.Bold>sucesso</S.Bold>!
          </S.Text>
        </S.Wrapper>
      </S.BlueBox>

      <ActionButton
        label="Baixar material"
        labelcolor="blue"
        style={{ width: '80%', maxWidth: '38rem' }}
        onClick={openModal}
      />

      <DownloadModal isOpen={isModalOpen} closeModal={closeModal} />
    </S.Container>
  );
};

export default Canvas;
